import styled from "styled-components";
import { headingStyle } from "styles/typography";
import { IoChevronBackSharp } from "react-icons/io5";
import { HorizontalFlexContainer } from "styles/flex";

export interface ModalStyleProps {
  width?: number;
}

export const ModalOuterContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const CenterInnerModalContainer = styled.div<ModalStyleProps>`
  position: relative;
  padding: 2rem;
  min-width: ${(props) => props.width ?? 40}rem;
  height: auto;
  overflow: auto;
  margin: 0 auto;
  background-color: #fff;
`;

export const RightSideInnerModalContainer = styled.div<ModalStyleProps>`
  position: absolute;
  min-width: ${(props) => props.width ?? 60}rem;
  height: 100vh;
  background: #ffffff;
  padding: 2rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled(HorizontalFlexContainer)`
  &&& {
    ${headingStyle({ scale: 1 })};
    display: flex;
    justify-content: space-between;
    margin: 0;
    height: 3rem;
  }
`;

export const StyledChevronBack = styled(IoChevronBackSharp)`
  &&& {
    vertical-align: middle;
    cursor: pointer;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const ModalHeadWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-right: 20px;
`;
export const PlaylistContainer = styled.div`
  .rdt_TableRow {
    cursor: default !important;
  }
`;
